import './melgroupleonda5/style';
import FormStructure from './melgroupleonda5/form_structure';

export default FormStructure;